/* eslint-disable no-unused-expressions */
import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CryptoJS from "crypto-js";

// layouts
import { MainLayout } from "layouts";

// components
import { Button } from "components/common";
import PasswordField from "components/form/PasswordField";

import { patchPasscode } from "api/user";

const PasswordCheck = () => {
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  const initialValues = {
    password: "",
    newPassword: "",
    passwordConfirm: "",
  };

  const validationSchema = Yup.object().shape({
    password: Yup.string().matches(
      /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*.]{8,16}$/,
      "8자 이상 숫자와 영어를 포함해서 입력해주세요"
    ),
    newPassword: Yup.string().matches(
      /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*.]{8,16}$/,
      "8자 이상 숫자와 영어를 포함해서 입력해주세요"
    ),
    passwordConfirm: Yup.string()
      .oneOf([Yup.ref("newPassword")], "새로운 비밀번호가 일치하지 않습니다")
      .required("새로운 비밀번호를 다시 입력해 주세요"),
  });

  const handleClickButton = (values) => {
    const secretkey = "bodycodi-manager";
    const key = CryptoJS.enc.Utf8.parse(secretkey.substring(0, 32));
    const iv = CryptoJS.enc.Utf8.parse(secretkey.substring(0, 16));

    const oldPassCode = CryptoJS.AES.encrypt(values.password, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();

    const passCode = CryptoJS.AES.encrypt(values.newPassword, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();

    patchPasscode({
      oldPassCode,
      passCode,
    })
      .then((result) => {
        if (result) {
          navigate(-2);
        }
      })
      .catch((e) => {});
  };

  const handlePasswordConfirmKeyUp = (e, formik) => {
    const currentConfirmValue = e.target.value;

    if (currentConfirmValue === formik.values.password) {
      // 비밀번호가 일치하면 에러를 지워줍니다
      formik.setFieldError("passwordConfirm", undefined);
      // 전체 폼 유효성을 다시 검사합니다
      formik.validateForm();
    }
  };

  return (
    <MainLayout
      withBottomTab={false}
      withHeader={true}
      backgroundColor="white"
      headerProps={{ withBackButton: true, centerTitle: "비밀번호 확인" }}
    >
      <Wrapper>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          validateOnChange={false}
          validateOnBlur={true}
          onSubmit={(values, actions) =>
            handleClickButton(values, actions.setFieldError)
          }
        >
          {(formik) => (
            <Form>
              <PasswordField
                name="password"
                label="기존 비밀번호 입력"
                maxLength={30}
                placeholder="기존 비밀번호를 입력해주세요"
                onChange={(e) => {
                  formik.setFieldValue("password", e.target.value);
                  failed ? setFailed(false) : null;
                }}
              />

              <Button
                type="button"
                variant="contained"
                className="square"
                padding="10px 16px"
                backgroundColor="#F3F7FF"
                color="#70747D"
                fontSize="15px"
                fontWeight={500}
                text="비밀번호가 기억나지 않나요?"
                onClick={() => navigate("/entrance/findpass")}
              />

              <br />
              <br />
              <br />

              <PasswordField
                name="newPassword"
                label="새로운 비밀번호"
                placeholder="새로운 비밀번호"
                withInstruction={true}
                instructionMsg={"8자 이상 숫자와 영어를 포함해서 입력해주세요"}
                maxLength={30}
              />
              <br />

              <PasswordField
                name="passwordConfirm"
                label="새로운 비밀번호 확인"
                maxLength={30}
                placeholder="새로운 비밀번호 확인"
                onKeyUp={(e) => handlePasswordConfirmKeyUp(e, formik)}
              />

              <BottomButtonWrapper>
                <Button
                  variant="contained"
                  className="square"
                  padding="16px"
                  text="비밀번호 변경"
                  disabled={
                    !formik.values.newPassword ||
                    !formik.values.passwordConfirm ||
                    formik.errors.newPassword ||
                    formik.errors.passwordConfirm
                  }
                  type="submit"
                />
              </BottomButtonWrapper>
            </Form>
          )}
        </Formik>
      </Wrapper>
    </MainLayout>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 16px 20px 0px 20px;

  button {
    margin-top: 16px;
  }
`;

const BottomButtonWrapper = styled.div`
  display: flex;
  padding: 0 20px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 40px;
`;

export default PasswordCheck;
